import $ from "jquery"
import DataTableFactory from "datatables.net-bs5"

DataTableFactory(window, $)

window.DataTable = function DataTable(selector, options) {
  if (typeof $.fn?.DataTable === "function") {
    return $(selector).DataTable(options)
  }

  return new DataTableFactory(selector, options)
}

if (typeof $.fn?.DataTable !== "function") {
  $.fn.DataTable = function DataTableCompat(options) {
    return new DataTableFactory(this, options)
  }
}

if (!$.fn.dataTable) {
  $.fn.dataTable = {}
}

if (typeof $.fn.dataTable.isDataTable !== "function" && typeof DataTableFactory.isDataTable === "function") {
  $.fn.dataTable.isDataTable = DataTableFactory.isDataTable.bind(DataTableFactory)
}

if (typeof $.fn.dataTable.tables !== "function" && typeof DataTableFactory.tables === "function") {
  $.fn.dataTable.tables = DataTableFactory.tables.bind(DataTableFactory)
}
